import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "m3.868 18.286-.235.8C1.796 18.547.58 17.332.018 15.472l.797-.24c.483 1.595 1.48 2.594 3.053 3.054M14.6 3.87l.797-.241c-.56-1.86-1.777-3.075-3.614-3.613l-.234.8c1.572.46 2.568 1.459 3.05 3.054M12.083 20c-.021 0 .023 0 0 0M20 7.072v5.141a7.13 7.13 0 0 1-2.092 5.027l-.68.675C15.873 19.26 13.992 20 12.083 20a7.1 7.1 0 0 1-5.064-2.177l-6.435-6.61C-.08 10.547-.19 9.494.333 8.767a1.87 1.87 0 0 1 1.147-.745l-.74-.74C.07 6.612-.04 5.557.482 4.83c.246-.341.634-.542 1.122-.582q.152-.011.312-.002c-.334-.63-.313-1.4.099-1.971A1.87 1.87 0 0 1 3.383 1.5a1.85 1.85 0 0 1 1.466.54l.291.29c.046-.254.145-.5.3-.716a1.862 1.862 0 0 1 2.833-.237l7.56 7.57V7.16c0-1.06.747-1.982 1.736-2.144a2.1 2.1 0 0 1 1.697.468c.467.397.734.975.734 1.588m-.833 0a1.25 1.25 0 0 0-1.464-1.233c-.59.096-1.036.664-1.036 1.322v3.801L7.684 1.967a1.027 1.027 0 0 0-1.567.135c-.288.4-.215.99.169 1.375l-.002.001 4.961 4.969-.59.589-6.396-6.407a1.025 1.025 0 0 0-1.567.135c-.288.4-.215.99.168 1.374L9.2 10.49l-.588.59-5.82-5.822c-.564-.564-1.533-.079-1.633.06-.287.399-.215.99.169 1.374l5.83 5.84-.59.589-3.992-4.003a1.027 1.027 0 0 0-1.568.135c-.288.4-.215.99.169 1.374l6.44 6.615a6.23 6.23 0 0 0 4.466 1.925c1.687 0 3.36-.654 4.558-1.844l.68-.675a6.3 6.3 0 0 0 1.846-4.435z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }